import React from 'react';
import '../less/childrens.less';
import Banner from '../../../../auxiliary-components/shared/Banner';
import banner_img from '../img/banner_img.png';
import TabsNew from '../../../../auxiliary-components/shared/TabsNew';
import usage_block_data from '../enums/usage_block_data.json';
import UsageBlock from '../../../../auxiliary-components/shared/UsageBlock';
import TextAboveFooter from '../../../../auxiliary-components/shared/TextAboveFooter/views/TextAboveFooter.c';
import Table from '../../../../auxiliary-components/shared/Table';
import table_data from '../enums/table_data.json';
import share_icon from '../../../Cards/ProjectSupport/img/share_icon.svg';
import FilesForDownload from '../../../../auxiliary-components/shared/FilesForDownload/views/file.c';
import Order from '../../views/orderAction';
import card_order_img from '../img/card_order_img.png';
import DownloadApp from "../../views/downloadApp.c";
import how_to_1 from "../img/how_to_1.png";
import how_to_2 from "../img/how_to_2.png";
import how_to_3 from "../img/how_to_3.png";
import HowToBlock from "../../../../auxiliary-components/shared/HowToBlock";
import QuestionsAdminBlock from "../../../../auxiliary-components/shared/QuestionsAdmin";
import { Preloader } from "MWComponents";
import SliderComponent from "../../../../auxiliary-components/shared/Slider";


export default function template() {
    const isMobile = this.isViewportMobile(),
      page = 'atb',
      {viewport} = this.props,
      modes = [ {mode: 'info', title: 'ATB_CARD_NAV_TITLE_1'},
        {mode: 'tariffs', title: 'ATB_CARD_NAV_TITLE_2'},
        {mode: 'questions', title: 'ATB_CARD_NAV_TITLE_3'}],
      mobileApp = (
        <div className="download-app-wrapper">
          <DownloadApp {...this.props} />
        </div>
      ),
      app = !isMobile ? (
          <div className="card-order-wrapper">
            <div className="left-side">
              <div className="title">{this.l10n('GC_WANT_TO_ORDER')}</div>
              <div className="sub-title">{this.l10n('GC_WANT_TO_ORDER_SUBTITLE')}</div>
              <div className="card-order">
                <div className="order-wrapper green-card">
                  <Order
                    {...this.props}
                    row={!isMobile}
                    utmParams={this.utmParams}
                    type="kid-card"
                  />
                </div>
              </div>
            </div>
            <img className="order-img" alt="card_order_img" src={card_order_img}></img>
          </div>
        )
        :
        mobileApp,
      howToItems = [
        { img: how_to_1, title: 'CHILDRENS_CARD_HOW_TO_TITLE_1', text: 'CHILDRENS_CARD_HOW_TO_TEXT_1' },
        { img: how_to_2, title: 'CHILDRENS_CARD_HOW_TO_TITLE_2', text: 'CHILDRENS_CARD_HOW_TO_TEXT_2' },
        { img: how_to_3, title: 'CHILDRENS_CARD_HOW_TO_TITLE_3', text: 'CHILDRENS_CARD_HOW_TO_TEXT_3' },
      ];
    return (
        <div className="childrens-card">
            <div className="repair-card-banner-wrapper">
              {this.state.loader ? <Preloader></Preloader> : <SliderComponent isMobile={isMobile} widget={this.widgetsHelper.getWidget.call(this, 'main_banner')}></SliderComponent>}
            </div>

          <TabsNew modes={modes} isMobile={isMobile} page={page} toggle={this.toggleMode} mode={this.state.mode}>
            <div className="wrapper" type={modes[0].mode}>
              <div className="content">

                <div className="usages-wrapper">
                  <UsageBlock isMobile={isMobile} page={'kid-card'} data={usage_block_data}></UsageBlock>
                </div>
                {/* <div className='map'>
                  <div className='map-title' dangerouslySetInnerHTML={{__html: this.l10n("KIDS_DRAW_TITLE")}}></div>
                  <button className='map-btn' onClick={() => window.open('/back_to_school', '_self')}>{this.l10n("KIDS_DRAW_BTN")}</button>
                </div> */}
                <div className="how-to-block-wrapper">
                  <div className="block-title">{this.l10n("CHILDRENS_CARD_HOW_TO_TITLE")}</div>
                  <HowToBlock data={howToItems} isMobile={isMobile} page={'shoping-atb'}></HowToBlock>
                </div>
                {app}
              </div>
            </div>
            <div className="wrapper" type={modes[1].mode}>
              <div className="content">
                <div className="table-wrap">
                  <Table data={table_data} page={page} isMobile={isMobile} toggle={this.toggleMode}></Table>
                  <div className="tariffs-desc">
                    {this.l10n('PROJECT_SUPPORT_INFO_TARIFFS_DESC_TEXT_1')}
                    <a className="link" href={`https://conditions-and-rules.a-bank.com.ua/media/uploads/Tarif/Zhovta_ua.pdf`} target="_blank">
                      {this.l10n('PROJECT_SUPPORT_INFO_TARIFFS_DESC_TEXT_2')}
                      <img alt="href_img" src={share_icon}></img>
                    </a>
                  </div>
                </div>
                {mobileApp}
              </div>
            </div>
            <div className="wrapper" type={modes[2].mode}>
              <div className="content">
                <QuestionsAdminBlock page={page} isMobile={isMobile} widget={this.widgetsHelper.getWidget.call(this, 'questions')}></QuestionsAdminBlock>
                {mobileApp}
              </div>
            </div>
          </TabsNew>


          <FilesForDownload lang={this.props.lang} widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}/>

          <div className={`disclaimer-wrapper tab-${this.state.mode === 'info' ? 'active' : 'hidden'}`} style={{marginBottom:-120}}>
              <TextAboveFooter widget={this.widgetsHelper.getWidget.call(this, 'text_above_footer')}></TextAboveFooter>
          </div>
        </div>
    );
}
